import { formatDateTimeFromString, formatTime } from 'shared/utils/formatting';

export const getShiftTimespan = (startDateTime: string, endDateTime: string) =>
  `${formatDateTimeFromString(startDateTime)} - ${formatTime(new Date(endDateTime))}`;
